import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { TerritoryCode } from '~/lib/territories/territories';

import { getBenchmarks } from '../lib/benchmarks';

interface BenchmarkQueryProps {
  partyId?: string;
  objective?: string;
  territoryCodes?: TerritoryCode[];
  platforms?: string[];
}

export function useBenchmarkQuery({
  partyId,
  objective,
  territoryCodes,
  platforms,
}: BenchmarkQueryProps) {
  return useQuery({
    enabled: !!partyId,
    queryKey: [
      'campaign-benchmarks',
      partyId,
      objective,
      territoryCodes,
      platforms,
    ],
    queryFn: () => {
      return getBenchmarks({
        partyId,
        objective,
        territoryCodes,
        platforms,
      });
    },
    placeholderData: keepPreviousData,
    // @TODO WMG1-429 - Move this to the global QueryClient config options
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });
}
